// Module
var code = "<md-button class=\"md-icon-button md-primary show-button margin-0\" ng-click=\"$ctrl.onShowPanel($event)\"> <md-icon md-svg-icon=\"show\"></md-icon> <md-tooltip>{{\"Show fields\" | translate}}</md-tooltip> </md-button> ";
// Exports
export default code;